import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { CartProvider } from "./context/CartContext";
import Storefront from "./pages/Storefront";
import ProductDetail from "./pages/ProductDetail";
import PlanDetail from "./pages/PlanDetail";
import Refunds from "./pages/Refunds";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";

const Protected = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center font-mono-x text-sm">Loading…</div>;
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
};

function App() {
  return (
    <div className="App grain">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<CartProvider><Storefront /></CartProvider>} />
            <Route path="/product/:id" element={<CartProvider><ProductDetail /></CartProvider>} />
            <Route path="/plan/:id" element={<CartProvider><PlanDetail /></CartProvider>} />
            <Route path="/refunds-returns" element={<Refunds />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<Protected><AdminDashboard /></Protected>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
      <Toaster position="top-right" />
    </div>
  );
}

export default App;
